export enum DisplayVariant {
  Variant1 = "VARIANT_1",
  Variant2 = "VARIANT_2",
}

export enum CategoryHeaderPosition {
  Top = "TOP",
  Left = "LEFT",
  Right = "RIGHT",
}
